var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.219971,
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2192 29.9976C58.2192 14.5336 45.6832 1.99756 30.2192 1.99756C14.7553 1.99756 2.21924 14.5336 2.21924 29.9976C2.21924 45.4615 14.7553 57.9976 30.2192 57.9976C45.6832 57.9976 58.2192 45.4615 58.2192 29.9976Z",
    fill: "url(#paint1_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22 57C15.3204 57 3.21997 44.8822 3.21997 30C3.21997 15.1178 15.3378 3 30.22 3C45.1021 3 57.22 15.1178 57.22 30C57.22 44.8822 45.1021 57 30.22 57Z",
    fill: "url(#paint2_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0899 15.1841C26.0899 18.5453 23.3724 21.2628 20.0113 21.2628C16.6501 21.2628 13.9326 18.5453 13.9326 15.1841C13.9326 11.823 16.6501 9.10547 20.0113 9.10547C23.3724 9.10547 26.0899 11.823 26.0899 15.1841Z",
    fill: "url(#paint3_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9899 15.1841C25.9899 18.49 23.3172 21.1628 20.0113 21.1628C16.7054 21.1628 14.0326 18.49 14.0326 15.1841C14.0326 11.8782 16.7054 9.20547 20.0113 9.20547C23.3172 9.20547 25.9899 11.8782 25.9899 15.1841Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0899 45.2735C26.0899 48.6346 23.3724 51.3522 20.0113 51.3522C16.6501 51.3522 13.9326 48.6346 13.9326 45.2735C13.9326 41.9123 16.6501 39.1948 20.0113 39.1948C23.3724 39.1948 26.0899 41.9123 26.0899 45.2735Z",
    fill: "url(#paint4_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9899 45.2735C25.9899 48.5794 23.3172 51.2522 20.0113 51.2522C16.7054 51.2522 14.0326 48.5794 14.0326 45.2735C14.0326 41.9676 16.7054 39.2948 20.0113 39.2948C23.3172 39.2948 25.9899 41.9676 25.9899 45.2735Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0899 30.22C26.0899 33.5812 23.3724 36.2987 20.0113 36.2987C16.6501 36.2987 13.9326 33.5812 13.9326 30.22C13.9326 26.8589 16.6501 24.1414 20.0113 24.1414C23.3724 24.1414 26.0899 26.8589 26.0899 30.22Z",
    fill: "url(#paint5_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9899 30.22C25.9899 33.5259 23.3172 36.1987 20.0113 36.1987C16.7054 36.1987 14.0326 33.5259 14.0326 30.22C14.0326 26.9141 16.7054 24.2414 20.0113 24.2414C23.3172 24.2414 25.9899 26.9141 25.9899 30.22Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5072 15.1841C46.5072 18.5453 43.7897 21.2628 40.4285 21.2628C37.0674 21.2628 34.3499 18.5453 34.3499 15.1841C34.3499 11.823 37.0674 9.10547 40.4285 9.10547C43.7897 9.10547 46.5072 11.823 46.5072 15.1841Z",
    fill: "url(#paint6_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4072 15.1841C46.4072 18.49 43.7344 21.1628 40.4285 21.1628C37.1226 21.1628 34.4499 18.49 34.4499 15.1841C34.4499 11.8782 37.1226 9.20547 40.4285 9.20547C43.7344 9.20547 46.4072 11.8782 46.4072 15.1841Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5072 45.2735C46.5072 48.6346 43.7897 51.3522 40.4285 51.3522C37.0674 51.3522 34.3499 48.6346 34.3499 45.2735C34.3499 41.9123 37.0674 39.1948 40.4285 39.1948C43.7897 39.1948 46.5072 41.9123 46.5072 45.2735Z",
    fill: "url(#paint7_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4072 45.2735C46.4072 48.5794 43.7344 51.2522 40.4285 51.2522C37.1226 51.2522 34.4499 48.5794 34.4499 45.2735C34.4499 41.9676 37.1226 39.2948 40.4285 39.2948C43.7344 39.2948 46.4072 41.9676 46.4072 45.2735Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_1_25908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5072 30.22C46.5072 33.5812 43.7897 36.2987 40.4285 36.2987C37.0674 36.2987 34.3499 33.5812 34.3499 30.22C34.3499 26.8589 37.0674 24.1414 40.4285 24.1414C43.7897 24.1414 46.5072 26.8589 46.5072 30.22Z",
    fill: "url(#paint8_linear_1_25908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4072 30.22C46.4072 33.5259 43.7344 36.1987 40.4285 36.1987C37.1226 36.1987 34.4499 33.5259 34.4499 30.22C34.4499 26.9141 37.1226 24.2414 40.4285 24.2414C43.7344 24.2414 46.4072 26.9141 46.4072 30.22Z",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1_25908",
    x: 11.9326,
    y: 7.10547,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_25908",
    x: 11.9326,
    y: 37.1948,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_1_25908",
    x: 11.9326,
    y: 22.1414,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_1_25908",
    x: 32.3499,
    y: 7.10547,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_1_25908",
    x: 32.3499,
    y: 37.1948,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_1_25908",
    x: 32.3499,
    y: 22.1414,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25908",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25908",
    x1: 59.4512,
    y1: 59.2312,
    x2: 0.988744,
    y2: 0.768773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25908",
    x1: 11.6886,
    y1: 11.4669,
    x2: 49.1889,
    y2: 48.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_25908",
    x1: 50.3689,
    y1: 49.6627,
    x2: 9.04013,
    y2: 10.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_25908",
    x1: 23.5868,
    y1: 19.4928,
    x2: 16.2312,
    y2: 10.4041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_25908",
    x1: 23.5868,
    y1: 49.5822,
    x2: 16.2312,
    y2: 40.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_25908",
    x1: 23.5868,
    y1: 34.5287,
    x2: 16.2312,
    y2: 25.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_25908",
    x1: 44.004,
    y1: 19.4928,
    x2: 36.6484,
    y2: 10.4041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_25908",
    x1: 44.004,
    y1: 49.5822,
    x2: 36.6484,
    y2: 40.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_25908",
    x1: 44.004,
    y1: 34.5287,
    x2: 36.6484,
    y2: 25.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.219971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB6);
export default __webpack_public_path__ + "static/media/b6.5ae3f40778cb6c459d414aed21756019.svg";
export { ForwardRef as ReactComponent };